import React, { forwardRef, useCallback, useImperativeHandle, useMemo, useReducer, useEffect } from 'react'

import { List, Box } from '@mui/material'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

import MessageItem from './MessageItem'
import defaultReducer from '../../utils/defaultReducer'

const SCROLLABLE_AREA_ID = 'cortex-scrollable-area'

const scrollDown = () => {
    const messageArea = document.getElementById(SCROLLABLE_AREA_ID)
    if (messageArea) messageArea.scrollTop = messageArea.scrollHeight
}

const MessageList = forwardRef(({ list, assistantUrl, accessToken, onSend, onCopy, onAction }, ref) => {
    const [state, setState] = useReducer(defaultReducer, { gluedBottom: true })

    useEffect(() => {
        if (state.gluedBottom || list[list.length]?.userId === 1)
            scrollDown()
    }, [list, state.gluedBottom])

    const detectPosition = useCallback((event) => {
        if ((event.target.scrollHeight - Math.round(event.target.scrollTop)) <= event.target.offsetHeight + 10) {
            setState({ gluedBottom: true })
            return
        }
        if (state.gluedBottom)
            setState({ gluedBottom: false })
    }, [state.gluedBottom])

    useImperativeHandle(ref, () => ({ scrollDown }))

    const messageList = useMemo(() => (
        <List onScroll={detectPosition} id={SCROLLABLE_AREA_ID}>
            {list.map((message, index) => (
                <MessageItem
                    key={`message-key-${index}`}
                    message={message}
                    assistantUrl={assistantUrl}
                    accessToken={accessToken}
                    onSend={onSend}
                    onCopy={onCopy}
                    onAction={onAction}
                />
            ))}
        </List>
    ), [list, detectPosition, assistantUrl, accessToken, onSend, onCopy, onAction])

    return (
        <>
            {messageList}
            {!state.gluedBottom &&
                <Box className="cortex-scrolldown-box" onClick={scrollDown}>
                    <Box sx={{ display: 'flex', alignItems: 'bottom' }}>
                        <ArrowDownwardIcon />
                    </Box>
                </Box>
            }
        </>
    )
})

export default MessageList
